export const getFileExtension = (url) => {
  if (!url) return "";
  const lastDot = url.lastIndexOf(".");
  return lastDot >= 0 ? url.substring(lastDot) : "";
};

export const buildDownloadFileName = (prefix, courseName, url) =>
  `${prefix}_${courseName}${getFileExtension(url)}`;
